import IBookingHistoryItem from "PFApp/booking/types/booking_history_item";
import { camelCase } from "PFCore/helpers/camel_case";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import React, { useMemo } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import css from "./booking_history_item.module.scss";

type IProps = {
  item: IBookingHistoryItem;
};

const BookingHistoryItem = ({
  item: {
    requester_name: requesterName,
    requester_id: requesterId,
    updated_attributes: updatedAttributes,
    created_at: createdAt,
    action
  }
}: IProps) => {
  const { t } = useTranslation(["bookingModule", "translation"]);
  const { formatDateTime, formatDate, utc } = useDateFormatter();

  const propertyNames = updatedAttributes
    ? Object.keys(updatedAttributes).join(", ")
    : t("translation:property");

  const formattedUpdatedAttributes = useMemo(() => {
    if (updatedAttributes) {
      const dateAttributes = ["start_date", "end_date"];
      return Object.keys(updatedAttributes).reduce((acc, attribute) => {
        let changes = updatedAttributes[attribute];
        if (dateAttributes.includes(attribute)) {
          changes = changes.map((date) => formatDateTime(utc(date)));
        }
        return [...acc, changes.join(" > ")];
      }, []);
    }
  }, [updatedAttributes]);

  return (
    <div className={css.root}>
      <div className={css.message}>
        <Trans
          i18nKey={`bookingModule:details.history.${camelCase(action)}`}
          t={t}
          components={[<Link key="0" className={css.profileName} to={`/profiles/${requesterId}`} />]}
          values={{ properties: propertyNames, profileName: requesterName }}
        />
        {formattedUpdatedAttributes && (
          <div className={css.changes}>
            {formattedUpdatedAttributes.map((change) => (
              <div key={change} className={css.change}>
                {change}
              </div>
            ))}
          </div>
        )}
      </div>
      <div>{formatDate(utc(createdAt))}</div>
    </div>
  );
};

export default BookingHistoryItem;
